import CryptoJS from 'crypto-js';

export function removeWatermarkToUrl(imageUrl) {
    const watermarkHash = CryptoJS.SHA256(imageUrl + 'shadeko').toString(CryptoJS.enc.Hex);
    const urlWithNoWatermark = `${imageUrl}?watermark=${watermarkHash}`;
    return urlWithNoWatermark;
}
